<template>
  <AppEditForm
    padding
    class="row q-px-md full-width"
    @save="save"
    :edit="edit"
    :new="isNew"
    dense
  >
    <div class="col-12 col-sm-8 q-mt-md row content-start">
      <div class="col-6 q-px-sm">
        <AppInput
          label="Número do processo paradigma"
          :mask="appStore.procPjeMask"
          v-model="numeroProcesso"
          required
          dense
        />
      </div>

    </div>

    <div class="col-1 ">
      <div class="q-pa-sm justify-end">
        <q-btn
          icon="add"
          color="positive"
          type="submit"
          fab
          class="on-right"
        />
      </div>
    </div>
  </AppEditForm>
</template>


<script setup>
import AppEditForm from "../app/AppEditForm.vue";
import AppInput from "../app/AppInput.vue";
import { useProcessoParadigmaStore } from "@/store/processoparadigma-store";
import { useAppStore } from "@/store/app-store";

import { ref, defineProps, defineEmits, watch } from "vue";

const appStore = useAppStore();
const procStore = useProcessoParadigmaStore();

const emit = defineEmits(["update:modelValue"]);
const save = v => {
  procStore.save();
  numeroProcesso.value = "";
  emit("update:modelValue", v);
};

defineProps({ modelValue: {} });

const numeroProcesso = ref(null);

watch(numeroProcesso, () => (procStore.numero = numeroProcesso.value));

const edit = ref(true);
const isNew = ref(true);
</script>

<style lang="scss" >
@import "@/styles/quasar.variables.sass";

.tjpa-select-input {
  max-height: 30vh !important;
}

.AppSelect__dialog {
  margin-top: 90px;
}
</style>
